import axios, { Method } from 'axios';
import { APIURL } from '../../consts/constants';


export const consume = (url : string, data : any , headers : any, method : Method) => axios({
    method,
    url: APIURL + url,
    data,
    headers
});